const value = {
    title: 'Access denied',
    message: 'Contact the administrator to open the section. If you have any questions, please contact our support',
  };

export default value;
